import { SectionDraftsPage } from '../pages/SectionDraftsPage'
import { useEditorialTitle } from './titleContext'

export function ClassicView() {
  const { section } = useEditorialTitle()
  return <SectionDraftsPage section={section} />
}
